var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 13 13",
    style: {
      enableBackground: "new 0 0 13 13"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0071CD;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.8,3.7C10.8,3.7,10.8,3.7,10.8,3.7L10,2.9C9.4,2.2,8.7,1.6,8,0.9C7.9,0.8,7.8,0.7,7.6,0.7c-1.6,0-2.9,0-4,0 c-0.2,0-0.5,0.1-0.7,0.2C2.3,1.2,2,1.7,2,2.4l0,6.1l0,2.1c0,0.5,0.2,0.9,0.5,1.2c0.3,0.3,0.7,0.5,1.2,0.5c0.9,0,1.8,0,2.6,0 c1.1,0,2.2,0,3.2,0c0.7,0,1.3-0.4,1.5-1.1C11,11,11,10.8,11,10.6c0-1.3,0-2.6,0-3.8l0-2.6C11,4.1,11,3.8,10.8,3.7z M7.1,3 c0,0.8,0.6,1.5,1.4,1.6c0.1,0,0.2,0,0.3,0h1.2v5.9c0,0.3-0.1,0.5-0.4,0.5c-0.1,0-0.1,0-0.2,0c-1.9,0-3.8,0-5.6,0 c-0.3,0-0.5-0.1-0.5-0.4c0-0.1,0-0.1,0-0.2c0-2.7,0-5.5,0-8.2c0-0.3,0.1-0.5,0.4-0.5c0,0,0.1,0,0.2,0h3.4v0.3 C7.1,2.4,7.1,2.7,7.1,3z M8.7,3.5c-0.3,0-0.5-0.2-0.5-0.4c0-0.1,0-0.3,0-0.4l0.9,0.9C8.9,3.5,8.8,3.5,8.7,3.5z M9.5,3.7L9.5,3.7 L9.5,3.7L9.5,3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.5,9C4.5,9,4.5,9,4.5,9C4.2,9,4.1,9.2,4.1,9.5c0,0.3,0.1,0.5,0.4,0.5c0.1,0,0.1,0,0.2,0h3.6 c0.1,0,0.2,0,0.2,0C8.8,9.9,9,9.7,9,9.5C9,9.2,8.8,9,8.6,9c-0.1,0-0.1,0-0.2,0H4.7C4.6,8.9,4.5,8.9,4.5,9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.6,7.1c-0.3,0-0.4,0.2-0.5,0.5C4,7.8,4.2,8,4.4,8.1c0.1,0,0.2,0,0.3,0c0.5,0,1,0,1.5,0s0.5,0,0.9,0 c0.1,0,0.1,0,0.2,0c0.3,0,0.5-0.3,0.5-0.5c0-0.3-0.2-0.5-0.5-0.5c-0.1,0-0.1,0-0.2,0H4.7C4.7,7.1,4.6,7.1,4.6,7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.4,6.1c0.1,0,0.2,0,0.3,0c0.5,0,0.7,0,1.1,0H6c0,0,0.1,0,0.1,0c0.3,0,0.5-0.3,0.5-0.5c0-0.3-0.2-0.5-0.5-0.5 c-0.1,0-0.1,0-0.2,0H4.7c-0.1,0-0.1,0-0.2,0c-0.3,0-0.4,0.2-0.5,0.5C4,5.8,4.2,6.1,4.4,6.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesIcon);
export default __webpack_public_path__ + "static/media/notesIcon.ef2cf447041950729f6b0c993df3d061.svg";
export { ForwardRef as ReactComponent };